import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { closeSidebar, openSidebar } from 'src/modules/App/actions'
import { getFromSettings, isAfterHours } from 'src/utils/helpers'
import Sidebar from './Sidebar'

const mapStateToProps = (state) => {
  const afterHours = getFromSettings(state, 'afterHours')
  const timeZone = parseFloat(getFromSettings(state, 'timeZone', 0))
  return {
    isSidebarVisible: state.appReducer.isSidebarVisible,
    isChatOnlyFeature: state.appReducer.isChatOnlyFeature,
    featuresAndOptions: state.appReducer.featuresAndOptions,
    features: getFromSettings(state, 'features', {}),
    chatOptions: getFromSettings(state, 'chatOptions', {}),
    isAfterHours: isAfterHours(afterHours, timeZone),
    isChatEmpty: state.chat.isChatEmpty,
    areAppActionsDisabled: state.nonPersistentAppReducer.areAppActionsDisabled,
    bannerNotification: getFromSettings(state, 'bannerNotification', {}),
    isNotificationHidden: state.appReducer.isNotificationHidden,
    notificationHeight: state.appReducer.notificationHeight
  }
}

const mapDispatchToProps = {
  closeSidebar,
  openSidebar,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar))
